import React from 'react';
import styled from 'styled-components';

export const AuthLoader = () => (
  <LoaderWrapper>
    <Loader />
  </LoaderWrapper>
);

const LoaderWrapper = styled.div`
  padding: 20px;
`;

const Loader = styled.div`
  position: absolute;
  width: 30px;
  height: 30px;
  left: calc(50% - 30px / 2);
  top: calc(50% - 30px / 2 - 1px);
  border: 2px solid #5c5c5c;
  border-right-color: transparent;
  border-radius: 50%;
  animation: loadingspin 1s linear infinite;

  @keyframes loadingspin {
    100% {
      transform: rotate(360deg);
    }
  }
`;
